import { render, staticRenderFns } from "./TickerAdminEditRecMulti.vue?vue&type=template&id=3ca9341c"
import script from "./TickerAdminEditRecMulti.vue?vue&type=script&lang=js"
export * from "./TickerAdminEditRecMulti.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports